import { apiFetch } from "../api";
import {BASE_URL} from "../../commonUrls";


const BASE_URL1 = `${BASE_URL}/recurring`;


export const getAllRecurring = async () => {
const res = await apiFetch(BASE_URL1);
if (!res.ok) return [];
const data = await res.json();
return Array.isArray(data) ? data : [];
};


export const createRecurring = async (data) => {
const res = await apiFetch(BASE_URL1, {
method: "POST",
body: JSON.stringify(data)
});
return res.json();
};


export const pauseRecurring = async (id) => {
await apiFetch(`${BASE_URL1}/${id}/pause`, { method: "POST" });
};


export const resumeRecurring = async (id) => {
await apiFetch(`${BASE_URL1}/${id}/resume`, { method: "POST" });
};
